import { Suspense } from "react";

import { graphql, useLazyLoadQuery } from "react-relay";
import { useSearchParams } from "react-router";

import { createSingleFilter } from "app/utils/filters";

import { SettingsTabsLayout } from "../SettingsTabsLayout";
import { UserList } from "../users/user-list/UserList";
import { type UsersSettingsRootQuery } from "./__generated__/UsersSettingsRootQuery.graphql";
import { AccessControlSettingsPage } from "./AccessControlSettingsPage";
import { UsersActionBar } from "./UsersActionBar";

export function UsersSettingsRoot() {
  const [searchParams] = useSearchParams({});
  const search = searchParams.get("search");

  const userFilterElement = search
    ? createSingleFilter("username", search, "contains")
    : undefined;

  const data = useLazyLoadQuery<UsersSettingsRootQuery>(
    graphql`
      query UsersSettingsRootQuery($userFilterElement: FilterElementInput) {
        ...AccessControlSettingsPage_query
        ...UserList_users @arguments(filterElement: $userFilterElement)
      }
    `,
    {
      userFilterElement,
    },
  );

  return (
    <AccessControlSettingsPage pageTitle="Users" queryRef={data}>
      <SettingsTabsLayout>
        <div className="flex w-full flex-col">
          <UsersActionBar />

          <Suspense fallback={null}>
            <UserList hasRoles={false} hasToolbar={false} queryRef={data} />
          </Suspense>
        </div>
      </SettingsTabsLayout>
    </AccessControlSettingsPage>
  );
}
